module.exports = __webpack_public_path__ + "media/src/images/apple-icon-57x57-d1678bfe05adcd72db02faa5b6a33f1d.png";